import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import {reducer as token} from 'api/auth';
import {reducer as notifications} from 'api/notifications';
import {deleteToken, setToken} from 'api/auth/auth';
// import {reducer as network} from 'modules/network';

export default (history, otherReducers) => {
  const reducer = combineReducers({
    router: connectRouter(history),
    ...otherReducers,
    token,
    notifications,
    // network,
  });
  return (state, action) => {
    if (state && [deleteToken.toString(), setToken.toString()].includes(action.type)) {
      return reducer({router: state.router, token: state.token}, action);
    }
    return reducer(state, action);
  };
};
